<!--
  MapLocationDialog.vue
    Map Location Dialog Component
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <v-dialog
    v-model="mDialog"
    fullscreen
    hide-overlay
    transition="slide-y-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card dark color="primary" app class="hm-iphonex-notch">
        <v-btn icon color="primary" @click="onClickClose">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t("settings.locationlist") }}</v-toolbar-title>
      </v-toolbar>

      <v-card-text
       id="hm-mpld-container"
       class="hm-mpld-container"
      >
      <div class="hm-iphonex-notch">
        <div class="fixed_area">
          <map-area :pmapid="mMapName" ref="maparea" class="hm-map-area"></map-area>

          <v-layout row wrap class="pa-1 search_area">
            <v-flex xs2 md1 align-center>
              <div class="hm-display-mobile">
              <v-btn flat icon color="primary" @click="onClickAll">
                <v-icon size="24">person_pin_circle</v-icon>
              </v-btn>
              </div>
              <div class="hm-display-monitor">
              <v-btn flat large icon color="primary" @click="onClickAll">
                <v-icon size="36">person_pin_circle</v-icon>
              </v-btn>
              </div>
            </v-flex>
            <v-flex xs2 md1 align-center>
              <div class="hm-display-mobile">
              <v-btn flat icon color="primary" @click="onClickClear">
                <v-icon size="20">location_off</v-icon>
              </v-btn>
              </div>
              <div class="hm-display-monitor">
              <v-btn flat large icon color="primary" @click="onClickClear">
                <v-icon size="32">location_off</v-icon>
              </v-btn>
              </div>
            </v-flex>
            <v-flex xs2 md1 align-center>
              <div class="hm-display-mobile">
              <v-btn flat icon color="primary" @click="onClickReload">
                <v-icon size="20">refresh</v-icon>
              </v-btn>
              </div>
              <div class="hm-display-monitor">
              <v-btn flat large icon color="primary" @click="onClickReload">
                <v-icon size="32">refresh</v-icon>
              </v-btn>
              </div>
            </v-flex>

            <v-flex xs6 md4 offset-md4>
              <v-text-field
                v-model="mSearchStr"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>

          <div class="hm-mpld-mplist">
            <v-divider />
            <v-layout row wrap align-center justify-center>
              <v-flex xs4 sm2 md2 class="hm-clr-prim-grey01 hm-mlv-header">Name</v-flex>
              <v-flex sm2 md2 class="hm-clr-prim-grey01 hm-mlv-header hm-display-monitor">
                Group
                <v-btn flat icon class="hm-mlv-header-btn" color="gery darken-1" @click="onClickCategorize"><v-icon>unfold_more</v-icon></v-btn>
              </v-flex>
              <v-flex xs5 sm6 md6 class="hm-clr-prim-grey01 hm-mlv-header">Message</v-flex>
              <v-flex xs3 sm2 md2 class="hm-clr-prim-grey01 hm-mlv-header">
                Time
                <span :class="{'hm-hide': !isTimesort}">
                <v-btn flat icon class="hm-mlv-header-btn" color="gery darken-1" @click="onClickTimesort">
                  <v-icon>arrow_downward</v-icon>
                </v-btn>
                </span>
                <span :class="{'hm-hide': isTimesort}">
                <v-btn flat icon class="hm-mlv-header-btn" color="gery darken-1" @click="onClickTimesort">
                  <v-icon>remove</v-icon>
                </v-btn>
                </span>
              </v-flex>
            </v-layout>
            <v-divider />
            <div id="hm-mpld-mplist-data" class="hm-mpld-mplist-data ">
            <map-location-info
              @locationInfoSelected="onLocationInfoSelected"
              v-for="locationInfo in filteredLocationInfo"
              :key="locationInfo.staff_id"
              :pLocationInfo="locationInfo"
            ></map-location-info>
            </div>
            <v-divider />

            <!--
            <v-data-table
              :headers="headers"
              :items="mGeoLocationList"
              :search="search"
              :disable-initial-sort=true
            >
              <template slot="items" slot-scope="row">
                <td class="small-font name">{{ row.item.name }}</td>
                <td class="location">
                  <v-icon
                    medium
                    color="primary"
                    @click="showLocation(row.item.latitude, row.item.longitude, row.item.staff_id)"
                  >person_pin_circle</v-icon>
                </td>
                <td class="small-font message">{{ row.item.message }}</td>
                <td class="small-font send_time">{{ row.item.send_time | formatTimestamp }}</td>
              </template>
              <template slot="no-data">
                <v-alert :value="true" color="error" icon="warning">
                  表示するデータがありません
                </v-alert>
              </template>
            </v-data-table>
            -->
          </div>
      </div>
      </v-card-text>
    </v-card>

    <errorinfo-dialog ref="errorInfoDialog">
      <div slot="msg">MAP位置情報の取得に失敗しました.</div>
    </errorinfo-dialog>
    <info-dialog-nodata ref="infoDialogNoData">
      <div slot="msg">
        位置情報は登録されていません.<br />
        送信時のメッセージ : {{ mSelectedUserSentMsg }}
      </div>
    </info-dialog-nodata>
    <popup-dialog ref="popupDialog">
      <div slot="msg">{{ mPopupMsg }}</div>
    </popup-dialog>
  </v-dialog>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import { mapState } from 'vuex'
import { isNullorUndefined, formatDateMoment } from '@/common'
import MapOSMOL from '@/components/MapOSMOL'
import MapLocationInfo from '@/components/MapLocationInfo'
import ErrorInfoDialog from '@/components/dialogs/ErrorInfoDialog'
import InfoDialog from '@/components/dialogs/SystemInfoDialog'
import PopupDialog from '@/components/dialogs/PopupDialog'

export default {
  name: 'MapLocationViewDialog',
  data: () => ({
    mDialog: false,
    mMapName: 'hm-map-list',
    mSelectedGeoLocationList: [],
    mTimesort: false,
    mCategorize: false,
    headers: [
      { text: 'name', value: 'name', sortable: false },
      { text: 'location', value: 'location', sortable: false },
      // { text: 'latitude', value: 'latitude', sortable: false },
      // { text: 'longitude', value: 'longitude', sortable: false },
      { text: 'message', value: 'message', sortable: false },
      {
        text: 'send time',
        value: 'send_time',
        sortable: true
      }
    ],
    mSearchStr: '',
    mSelectedUserSentMsg: '',
    mMapRendered: false,
    mMapZoom: 15,
    mPopupMsg: '',
  }),
  components: {
    'map-area': MapOSMOL,
    'map-location-info': MapLocationInfo,
    'errorinfo-dialog': ErrorInfoDialog,
    'info-dialog-nodata': InfoDialog,
    'popup-dialog': PopupDialog,
  },
  mounted: function () {
    this.$log.debug('# MapLocationViewDialog')
    // メニューがクリックされた時のハンドラを登録
    this.$on('onClickMapLocationList', this.onClickMapLocationList)
    this.mSelectedGeoLocationList = this.mGeoLocationList
  },
  destroyed: function () {
    this.$log.debug('# MapLocationViewDialog')
  },
  computed: {
    ...mapState({
      mGeoLocationList: state => state.geoLocation.sGeoLocationList,
      mUserList: state => state.sUserList,
      mGroupList: state => state.sGroupList,
    }),
    filteredLocationInfo: function () {
      let gl_list = this.mSelectedGeoLocationList

      // ユーザ情報を付加する
      for (let gl_info of gl_list) {
        gl_info = this._addUserInfo(gl_info)
      }

      // 組織名を付加する
      for (let gl_info of gl_list) {
        gl_info = this._addGroupInfo(gl_info)
      }

      // 検索されている場合
      if (this.mSearchStr !== '') {
        gl_list = gl_list.filter((elm) => {
          return (
            (elm.name.indexOf(this.mSearchStr) !== -1) ||
            (elm.name_phonetic.indexOf(this.mSearchStr) !== -1) ||
            (elm.group_name.indexOf(this.mSearchStr) !== -1) ||
            (elm.message.indexOf(this.mSearchStr) !== -1)
          )
        })
      }

      // 表示順にソート
      gl_list.sort((a, b) => {
        if (a.vieworder < b.vieworder) return -1
        if (a.vieworder > b.vieworder) return 1
        return 0
      })
      if (this.mCategorize) {
        gl_list.sort((a, b) => {
          if (a.group_id < b.group_id) return -1
          if (a.group_id > b.group_id) return 1
          if (a.vieworder < b.vieworder) return -1
          if (a.vieworder > b.vieworder) return 1
          return 0
        })
      }

      if (this.mTimesort) {
        gl_list.sort((a, b) => {
          if (a.send_time > b.send_time) return -1
          if (a.send_time < b.send_time) return 1
          return 0
        })
        if (this.mCategorize) {
          gl_list.sort((a, b) => {
            if (a.group_id < b.group_id) return -1
            if (a.group_id > b.group_id) return 1
            if (a.send_time > b.send_time) return -1
            if (a.send_time < b.send_time) return 1
            return 0
          })
        }
      }

      this.$log.debug(JSON.stringify(gl_list))
      return gl_list
    },
    isTimesort: function () {
      return this.mTimesort
    },
  },
  filters: {
    formatTimestamp: function (time) {
      return formatDateMoment(time, 'YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    // -------------------------------------------------------------------------
    getGeoLocationList: async function () {
      const result = await this.$store.dispatch(
        'aGetGeoLocationList',
        this.$store.getters.loginUserCompanyId
      )
      if (!result.error && !result.body.error) {
        this.mSelectedGeoLocationList = this.mGeoLocationList
      }
      else {
        this.$refs.errorInfoDialog.$emit('show')
      }
    },
    // -------------------------------------------------------------------------
    onClickMapLocationList: function () {
      this.$store.commit('setIsWhereaboutsPage', false)  // 行動予定一覧の更新を行わない
      this.mDialog = true // Show Dialog

      // 地図初期化
      this.$refs.maparea.renderMap()
      /*if (this.mMapRendered === true) {
        // 地図初期化
        document.getElementById('hm-map-list').innerHTML = ''
        this.$refs.maparea.renderMap()
      }
      else {
        this.mMapRendered = true
      }*/
      this.getGeoLocationList()
      this.$nextTick(() => {
        // DOM生成完了後に実行
        document.getElementById('hm-mpld-mplist-data').scrollTop = 0
      })
    },
    // -------------------------------------------------------------------------
    onLocationInfoSelected: function (locationInfo, msgPopup) {
      if (isNullorUndefined(locationInfo.send_time) || locationInfo.send_time === '') {
        return
      }
      if ((this.$refs.maparea.hasMarker(locationInfo.staff_id)) &&
          msgPopup === true) {
        // ピン表示済みで、
        // メッセージポップアップ表示対象(省略表示(末尾が...)されているメッセージ欄をクリック)の場合
        // メッセージをポップアップ表示する
        this.mPopupMsg = locationInfo.message
        this.$refs.popupDialog.$emit('show')
        return
      }
      this.showLocation(
        locationInfo.staff_id,
        locationInfo.latitude,
        locationInfo.longitude,
        locationInfo.message,
      )
    },
    // -------------------------------------------------------------------------
    showLocation: function (staff_id, lat, lon, message) {
      this.mSelectedUserSentMsg = ''
      if (isNullorUndefined(lat) ||
          lat === '' ||
          Number.isNaN(Number(lat))) {
        if (isNullorUndefined(message) || message === '') {
          this.mSelectedUserSentMsg = 'なし'
        }
        else {
          this.mSelectedUserSentMsg = message
        }
        this.$refs.infoDialogNoData.$emit('show')
        return
      }
      if (isNullorUndefined(lon) ||
          lon === '' ||
          Number.isNaN(Number(lon))) {
        if (isNullorUndefined(message) || message === '') {
          this.mSelectedUserSentMsg = 'なし'
        }
        else {
          this.mSelectedUserSentMsg = message
        }
        this.$refs.infoDialogNoData.$emit('show')
        return
      }
      this._showLocation(staff_id, lat, lon, message)
    },
    // -------------------------------------------------------------------------
    _showLocation: function (staff_id, lat, lon, message) {
      if (this.$refs.maparea.hasMarker(staff_id)) {
        this.$refs.maparea.removeMarker(staff_id)
      }
      else {
        this.$refs.maparea.setMarker(this.mMapZoom, lon - 0, lat - 0, staff_id) // 数値型指定するため-0
      }
    },
    // -------------------------------------------------------------------------
    _addUserInfo: function (geoLocationInfo) {
      const user_info = this.mUserList.find((elm) => {
        return (elm.staff_id.toString() === geoLocationInfo.staff_id.toString())
      })
      if (!isNullorUndefined(user_info)) {
        geoLocationInfo.vieworder = user_info.vieworder
        geoLocationInfo.name_phonetic = user_info.name_phonetic
      }
      else {
        geoLocationInfo.vieworder = 'not found'
        geoLocationInfo.name_phonetic = ''
      }
      return geoLocationInfo
    },
    // -------------------------------------------------------------------------
    _addGroupInfo: function (geoLocationInfo) {
      const user_info = this.mUserList.find((elm) => {
        return (elm.staff_id.toString() === geoLocationInfo.staff_id.toString())
      })
      if (!isNullorUndefined(user_info)) {
        geoLocationInfo.group_id = user_info.group_id
        const group = this.mGroupList.find((elm) => {
          return (elm.group_id.toString() === user_info.group_id.toString())
        })
        if (!isNullorUndefined(group)) {
          geoLocationInfo.group_name = group.g_name
        }
        else {
          geoLocationInfo.group_name = ''
        }
      }
      else {
        geoLocationInfo.group_id = ''
        geoLocationInfo.group_name = ''
      }

      return geoLocationInfo
    },
    // -------------------------------------------------------------------------
    onClickTimesort: function () {
      this.mTimesort = !this.mTimesort
    },
    // -------------------------------------------------------------------------
    onClickCategorize: function () {
      this.mCategorize = !this.mCategorize
    },
    // -------------------------------------------------------------------------
    onClickAll: function () {
      this.$refs.maparea.clearMarker()
      for (let elm of this.mGeoLocationList) {
        if (isNullorUndefined(elm.latitude) ||
            elm.latitude === '' ||
            Number.isNaN(Number(elm.latitude))) {
          continue
        }
        if (isNullorUndefined(elm.longitude) ||
            elm.longitude === '' ||
            Number.isNaN(Number(elm.longitude))) {
          return
        }
        this._showLocation(elm.staff_id, elm.latitude, elm.longitude, elm.message)
      }
    },
    // -------------------------------------------------------------------------
    onClickClear: function () {
      this.$refs.maparea.clearMarker()
    },
    // -------------------------------------------------------------------------
    onClickReload: function () {
      this.getGeoLocationList()
    },
    // -------------------------------------------------------------------------
    onClickClose: function () {
      this.$store.commit('setIsWhereaboutsPage', true)   // 行動予定一覧の更新を行う
      this.mDialog = false
      document.getElementById('hm-map-list').innerHTML = ''
      this.onClickClear()
    },
  }
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.hm-mpld-container {
  margin-top: calc(64px - 16px);   /* v-cardのpadding16pxをヘッダにかぶせる */
}
@media screen and (min-width: 601px) {
  /* 幅601px～ */
  .hm-mpld-container {
    width: calc(100vw - 17px);
  }
}
.fixed_area {
  /*position: fixed;
  top: 0;*/
  height: 45vh;
  width: 100%;
  z-index: 2;
  background-color: white;
}
.hm-map-area {
  width: 95%;
  height: 35vh;
  margin: 10px auto;
}
.search_area {
  width: 100%;
  /*margin-right: 20px;*/
}
.hm-mpld-mplist {
  /*margin-left: 5px;
  margin-right: 5px;*/
  height: calc((55vh - 64px - 16px - 16px) - var(--iphonex-notch, 0));  /* 55vh(fixed_area以外)-64px(タイトル)-16px(タイトルにかぶせたcardのpadding)-16px())*/
  background: white;
}
/*@media screen and (min-width: 601px) {
  /* 幅601px～
  .hm-mpld-mplist {
    height: calc(55vh - 64px - 16px - 16px);
  }
}*/
.hm-mpld-mplist-data {
  overflow-y: scroll;
  height: calc(100% - 40px);
}
.hm-mlv-header {
  height: 40px;
  line-height: 40px;
  padding-top: 5px;
  padding-bottom: 5px;
  font-weight: bold;
}
.hm-mlv-header-btn {
  width: 10px;
}

/*
.small-font {
  font-size: 0.8em;
}
.scroll {
  max-width: 380px;
  overflow: auto;
  white-space: nowrap;
}
.scroll::-webkit-scrollbar {
  height: 5px;
}
.scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.scroll::-webkit-scrollbar-thumb {
  background: #bcbcbc;
}
table {
  table-layout: fixed;
  min-width: 100%;
  word-break: break-word;
}
.name
 {
  width: 110px;
  min-width: 110px;
}
.location {
  width: 20px;
  min-width: 20px;
}
.message
 {
  width: 150px;
  min-width: 150px;
}
.send_time
 {
  width: 100px;
  min-width: 100px;
}*/
</style>



// WEBPACK FOOTER //
// src/components/dialogs/MapLocationViewDialog.vue